<template>
  <div class="quiz_situation_content">
    <div class="questions-wrapper">
      <div class="top-wrapper">
        <p class="q_index">
          {{ curPage + 1 }}.
          <span v-if="questionContent.qtype === 'singlechoice'">[单选题]</span>
          <span v-else-if="questionContent.qtype === 'multichoice'">[多选题]</span>
          <span v-else-if="questionContent.qtype === 'essay'">[简答题]</span>
          <span v-else-if="questionContent.qtype === 'truefalse'">[判断题]</span>
          <span v-else-if="questionContent.qtype === 'shortanswer'">[填空题]</span>
          <span v-else-if="questionContent.qtype === 'numerical'">[数字题]</span>
          <span v-else>[{{ questionContent.name }}]</span>
        </p>
        <p class="q_index q_title"
           v-html="questionContent.content"></p>
      </div>
      <div class="bottom-wrapper">
        <van-row class="h100">
          <van-col :span="isShow ? 14 : 24"
                   class="h100">
            <div v-for="(items, index) in questionContent.choices"
                 :key="index"
                 class="answer-wrapper"
                 :class="handleAnswers(items.id, index) ? 'right' : ''">
              <div class="leffter">{{ items.id }}.</div>
              <p v-html="items.content"></p>
            </div>
          </van-col>
          <van-col :span="isShow ? 10 : 0"
                   class="h100">
            <div class="chart-wrapper"
                 v-show="isShow"
                 id="chart"></div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="tools-bar">
      <div class="menu click_able"
           @click="quiz_select_show = true">
        <van-image width="40px"
                   height="40px"
                   src="/images/thumb.png" />
      </div>
      <div class="question prev click_able"
           :class="[curPage - 1 < 0 ? 'ban' : '']"
           @click="prevQuestion">
        上一题
      </div>
      <div class="question next click_able"
           :class="[curPage >= questionsList.length - 1 ? 'ban' : '']"
           @click="nextQuestion">
        下一题
      </div>
    </div>
    <van-overlay :show="quiz_select_show">
      <quizselect @closeSelect="closeSelect"></quizselect>
    </van-overlay>
  </div>
</template>

<script>
// @ is an alias to /src
import "echarts";
import Vue from "vue";
import { Image, Row, Col, Overlay, Button, Dialog, Toast } from "vant";
import quizselect from "@/components/home/quizselect";
import course from "@/api/course/index";
Vue.use(Image).use(Overlay).use(Row).use(Col).use(Button).use(Toast);
export default {
  components: {
    quizselect,
  },
  data () {
    return {
      quizid: "",
      codeid: "",
      questionsList: [],
      curPage: 0,
      qType: "",
      typeName: "",
      questionText: "",
      letterOptions: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      sum: 0,
      answers: [],
      chart: null,
      isShow: true,
      quiz_select_show: false,
      chartData: [],
      valueData: [],
      questionContent: {},
    };
  },
  methods: {
    nextPageTest () {
      this.chartData = ["A", "B", "C", "D"];
      this.valueData = [50, 10, 20, 30];
      this.initEcharts();
    },
    initEcharts () {
      let option = {
        color: ["#37AB7E"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.chartData,
            axisLabel: {
              textStyle: {
                color: "#333", // 更改坐标轴文字颜色
                fontSize: 30, // 更改坐标轴文字大小
              },
            },
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            show: false,
            type: "value",
            name: "人数:",
            axisLabel: {
              formatter: "{value} 人",
            },
          },
        ],
        series: [
          {
            name: "人数",
            type: "bar",
            itemStyle: {
              normal: {
                label: {
                  formatter: (res) => {
                    let { data } = res;
                    console.warn("value", data);
                    return `${data}人`;
                  },
                  show: true,
                  position: "top",
                  textStyle: {
                    fontSize: "24",
                  },
                },
              },
            },
            data: this.valueData,
          },
        ],
      };
      var charts = document.getElementById("chart");
      this.chart = this.$echarts.init(charts);
      this.chart.clear();
      this.chart.setOption(option);
      window.onresize = this.chart.resize;
    },
    handleQuesion () {
      console.log(this.questionsList);
      let { name, questiontext, qtype, answers } = this.questionsList[
        this.curPage
      ];
      this.qType = qtype;
      this.typeName = name;
      this.questionText = questiontext;
      this.answers = answers;
      if (qtype === "singlechoice" || qtype === "multichoice") {
        this.initEcharts();
      }
    },
    // 下一题
    nextQuestion () {
      console.log("======>", this.curPage);
      if (this.curPage < this.questionsList.length - 1) {
        this.curPage++;
        let { name, questiontext } = this.questionsList[this.curPage];
        this.qType = name;
        this.questionText = questiontext;
        this.getQuestionDetail();
      }
    },
    // 上一题
    prevQuestion () {
      if (this.curPage > 0) {
        this.curPage--;
        // this.handleQuesion()
        this.getQuestionDetail();
      }
    },
    closeSelect (flag) {
      this.quiz_select_show = flag;
    },
    handleAnswers (qid, index) {
      let { rightanswer } = this.questionContent;
      if (this.questionContent.qtype === "truefalse") {
        return rightanswer[0] === this.questionContent.choices[index].content;
      } else {
        return rightanswer.some((item) => item === qid);
      }
    },
    async getQuestionDetail () {
      if (!this.questionsList.length) {
        this.$dialog
          .alert({ message: "该测验没有添加题目，点击确定回到首页" })
          .then(() => {
            this.$router.push("/home");
          });
        return;
      }
      let result = await course.getQuizQustionDetail({
        params: {
          codeid: this.codeid,
          quizid: this.quizid,
          questionid: this.questionsList[this.curPage].id,
        },
        loadingText: "正在获取课程测验问题详细信息",
        errorFn: (error) => {
          if (!error.code) {
            // this.$router.push('/home')
          }
        },
      });
      if (result) {
        let {
          choices,
          content,
          key,
          name,
          qtype,
          rate,
          rightanswer,
          value,
        } = result;
        this.questionContent = result;
        if (qtype === "truefalse") {
          key.forEach((v, index) => {
            this.questionContent.choices.push({
              id: this.letterOptions[index],
              content: `${v}`,
            });
          });
        }
        if (qtype === "shortanswer" || qtype === "essay") {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
        console.log("result", this.questionContent);
        this.chartData = key;
        this.valueData = value;
        console.log(2222);
        this.initEcharts();
      }
    },
    handleError () { },
    async getQuestions () {
      let resp = await course.getQuestionIds({
        params: {
          courseid: this.$store.state.course.courseId,
          quizid: this.quizid,
        },
        loadingText: "正在获取课程测验问题列表",
        errorFn: (error) => {
          this.handleAnswers(error);
        },
      });
      if (resp) {
        this.questionsList = resp.questioncontents.map((v, index) => {
          let penalty = parseFloat(v.penalty).toFixed(4) * 100;
          return {
            answers: v.answers,
            questiontext: v.questiontext,
            rightanswer: v.rightanswer,
            qtype: v.qtype,
            id: v.id,
            name: v.name,
            accuracy: 100 - penalty,
            penalty: penalty,
          };
        });
        await this.getQuestionDetail();
      } else {
        this.handleError();
      }
    },
    async onmessage () {
      const _this = this;
      this.$root.$on("changePage", ({ curPage }) => {
        _this.curPage = curPage;
        _this.$store.commit("course/setValue", {
          name: "curPage",
          value: curPage,
        });
        _this.getQuestionDetail();
      });
    },
  },
  created () {
    this.$root.$off("changePage");
    this.onmessage();
  },
  mounted () {
    // var timestamp1 = new Date(1472048779952); //直接用 new Date(时间戳) 格式转化获得当前时间
    // var date =
    //   timestamp1.toLocaleDateString().replace(/\//g, "-") +
    //   " " +
    //   timestamp1.toTimeString().substr(0, 8);
    // console.log(date);
    // console.log("date", new Date("2016-8-24 22:26").getTime()); //再利用拼接正则等
    // console.warn("time", ~new Date());
    let { qid, cid } = this.$route.query;
    this.quizid = qid ? parseInt(qid) : this.$store.state.course.quizId;
    this.codeid = cid || this.$store.state.course.qcodeid;
    this.getQuestions();
  },
};
</script>
<style lang="less" scoped>
.chart-wrapper {
  width: 100%;
  height: 85%;
}
.tools-bar {
  position: fixed;
  right: 80px;
  top: 90px;
  width: 80px;
  height: auto;
  .menu {
    background: #ffd723;
    padding: 18px 12px;
    border-radius: 0 20px 20px 0;
  }
  .question {
    padding: 18px 12px;
    width: 50px;
    background: #ffd723;
    border-radius: 0 20px 20px 0;
    color: #064134;
    word-break: break-all;
    font-size: 32px;
    font-weight: bold;
    margin-top: 20px;
  }
  .prev {
    top: 156px;
  }
  .next {
    top: 330px;
  }
}
.quiz_situation_content {
  height: 100%;
  position: relative;
  padding: 50px 160px;
  z-index: 9;
  .h100 {
    height: 100%;
  }
  .ban {
    color: rgba(6, 65, 52, 0.5);
  }
  .q_index {
    color: #333333;
    font-size: 36px;
    font-weight: bold;
    word-break: break-all;
    span {
      color: #37ab7e;
    }
  }
  .q_title {
    margin-bottom: 30px;
  }
  .questions-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 48px;
    padding: 60px;
    position: relative;
    .bottom-wrapper {
      flex: 1;
      overflow: auto;
    }
  }

  .answer-wrapper {
    display: flex;
    color: #333333;
    font-size: 30px;
    line-height: 40px;
    margin-top: 30px;
    &.right {
      color: #4cb48c;
      font-weight: bold;
    }
  }
}
</style>